import { render, staticRenderFns } from "./create_class.vue?vue&type=template&id=ad9b7ac4&scoped=true"
import script from "./create_class.vue?vue&type=script&lang=js"
export * from "./create_class.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/class-create.scss?vue&type=style&index=0&id=ad9b7ac4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9b7ac4",
  null
  
)

export default component.exports